import { benchmarks } from './constants';

// Format time for display
export const formatTime = (timestamp: number): string => {
  return `${timestamp.toFixed(2)}ms`;
};

// Get performance rating based on metrics
export const getRating = (metric: string, value: number): string => {
  switch (metric) {
    case 'responseTime':
      if (value <= benchmarks.responseTime.excellent) return 'Excellent';
      if (value <= benchmarks.responseTime.good) return 'Good';
      if (value <= benchmarks.responseTime.acceptable) return 'Acceptable';
      return 'Poor';
    case 'successRate':
      if (value >= benchmarks.successRate.excellent) return 'Excellent';
      if (value >= benchmarks.successRate.good) return 'Good';
      if (value >= benchmarks.successRate.acceptable) return 'Acceptable';
      return 'Poor';
    case 'throughput':
      if (value >= benchmarks.throughput.stress) return 'Stress Level';
      if (value >= benchmarks.throughput.high) return 'High Load';
      if (value >= benchmarks.throughput.typical) return 'Typical Load';
      return 'Light Load';
    default:
      return 'N/A';
  }
};

// Get className for rating
export const getRatingClass = (rating: string): string => {
  switch (rating) {
    case 'Excellent': return 'text-success';
    case 'Good': return 'text-success';
    case 'Acceptable': return 'text-warning';
    case 'Poor': return 'text-danger';
    case 'Stress Level': return 'text-danger';
    case 'High Load': return 'text-warning';
    case 'Typical Load': return 'text-success';
    case 'Light Load': return 'text-info';
    default: return '';
  }
};

// Calculate performance score - lower is better
export const calculatePerformanceScore = (averageResponseTime: number, successRate: number): number => {
  return (averageResponseTime / 100) + (100 - successRate) * 5;
}; 